// extracted by mini-css-extract-plugin
module.exports = {"releaseToPatientLine":"release-activity-log-module__releaseToPatientLine___2ehM1"};